import type { RoutedActionHandler } from "../../app/actions.ts";

export interface TaskDetailActionCapabilities {
  parseTitle(): void;
  setDueDate(days: number): void;
  open(id: string): void | Promise<void>;
  edit(id: string): void | Promise<void>;
  toggleSubtask(taskId: string, subtaskId: string, target: HTMLElement): void | Promise<void>;
  transferSubtask(taskId: string, subtaskId: string): void | Promise<void>;
  promoteSubtask?(taskId: string, subtaskId: string): void | Promise<void>;
  toggleComplete(id: string): void | Promise<void>;
  deleteTask(id: string): void | Promise<void>;
  quickAdd(boardTag?: string): void | Promise<void>;
  focus(id: string, minutes?: number): void | Promise<void>;
}

const names = new Set(["parse-task-title", "set-due-date", "edit", "edit-task", "toggle-view-subtask", "transfer-view-subtask", "promote-view-subtask", "toggle", "delete", "quick-add", "focus-task"]);

export function createTaskDetailActionHandler(capabilities: TaskDetailActionCapabilities): RoutedActionHandler {
  return async (name, target) => {
    if (!names.has(name)) return false;
    if (name === "parse-task-title") capabilities.parseTitle();
    if (name === "set-due-date") capabilities.setDueDate(Number(target.dataset.days) || 0);
    if (name === "edit") await capabilities.open(target.dataset.id || "");
    if (name === "edit-task") await capabilities.edit(target.dataset.id || "");
    if (name === "toggle-view-subtask") await capabilities.toggleSubtask(target.dataset.task || "", target.dataset.subtask || "", target);
    if (name === "transfer-view-subtask") await capabilities.transferSubtask(target.dataset.task || "", target.dataset.subtask || "");
    if (name === "promote-view-subtask") await capabilities.promoteSubtask?.(target.dataset.task || "", target.dataset.subtask || "");
    if (name === "toggle") await capabilities.toggleComplete(target.dataset.id || "");
    if (name === "delete") await capabilities.deleteTask(target.dataset.id || "");
    if (name === "quick-add") await capabilities.quickAdd(target.dataset.boardTag);
    if (name === "focus-task") await capabilities.focus(target.dataset.id || "", target.dataset.minutes ? Number(target.dataset.minutes) : undefined);
    return true;
  };
}
